import { twMerge } from "tailwind-merge";

interface SectionProps {
  label: string;
  className?: string;
  labelClassName?: string;
  children: React.ReactNode;
}

const Section = ({
  label,
  className,
  labelClassName,
  children
}: SectionProps) => {
  return (
    <div className={twMerge("flex flex-col gap-2", className)}>
      <label
        className={twMerge("text-txtPlaceholder font-bold", labelClassName)}
      >
        {label}
      </label>
      {children}
    </div>
  );
};

export default Section;
